import { Link } from "react-router-dom";
import { useState } from "react";

const lifePosts = [
  {
    id: 1,
    user: "Sarah M.",
    avatar: "https://public.readdy.ai/ai/img_res/c360520252fdefb48850e6caae953e5d.jpg",
    platform: "instagram",
    followers: "42K",
    image: "https://readdy.ai/api/search-image?query=happy%20family%20enjoying%20new%20home%20appliances%20kitchen%20lifestyle%20photo%20warm%20cozy%20interior&width=600&height=400&seq=sbp-post1&orientation=landscape",
    caption: "Just shared this amazing kitchen set from a verified factory — my followers loved it! Already earned $320 in commissions this week. Life is good! 🏠",
    likes: "8.4K",
    comments: 312,
    earned: "$320",
    tag: "Kitchen & Home",
  },
  {
    id: 2,
    user: "James T.",
    avatar: "https://readdy.ai/api/search-image?query=young%20man%20confident%20smile%20portrait%20casual%20outdoor%20natural%20light&width=80&height=80&seq=sbp-avatar2&orientation=squarish",
    platform: "youtube",
    followers: "128K",
    image: "https://readdy.ai/api/search-image?query=man%20unboxing%20electronics%20gadgets%20YouTube%20review%20setup%20desk%20professional%20lighting&width=600&height=400&seq=sbp-post2&orientation=landscape",
    caption: "Unboxed these factory-direct gadgets for my YouTube channel — 128K subscribers went crazy! Commission check incoming. Share more, earn more!",
    likes: "21K",
    comments: 874,
    earned: "$1,240",
    tag: "Electronics",
  },
  {
    id: 3,
    user: "Lily Chen",
    avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20lifestyle%20influencer%20portrait%20smiling%20natural%20makeup%20warm%20tone&width=80&height=80&seq=sbp-avatar3&orientation=squarish",
    platform: "tiktok",
    followers: "890K",
    image: "https://readdy.ai/api/search-image?query=woman%20showing%20fashion%20clothing%20haul%20TikTok%20style%20colorful%20outfits%20lifestyle&width=600&height=400&seq=sbp-post3&orientation=landscape",
    caption: "My TikTok fashion haul from verified factories went viral! 2.1M views and my family's grocery bill is covered for the whole year. Thank you StarBookPrime!",
    likes: "94K",
    comments: 5200,
    earned: "$4,800",
    tag: "Fashion",
  },
];

const platformIcon: Record<string, string> = {
  instagram: "ri-instagram-line",
  youtube: "ri-youtube-line",
  tiktok: "ri-tiktok-line",
};

const platformColor: Record<string, string> = {
  instagram: "text-pink-500",
  youtube: "text-red-500",
  tiktok: "text-gray-900",
};

const platformBg: Record<string, string> = {
  instagram: "bg-pink-50 border-pink-200",
  youtube: "bg-red-50 border-red-200",
  tiktok: "bg-gray-50 border-gray-200",
};

const steps = [
  {
    icon: "ri-camera-line",
    title: "Share Your Life",
    desc: "Post photos & videos of products you love — just like Facebook, but you earn while you share.",
    color: "bg-orange-50",
    iconColor: "text-orange-500",
  },
  {
    icon: "ri-store-2-line",
    title: "Pick Verified Products",
    desc: "Choose from 1 Million+ verified factory products to feature on your YouTube, TikTok, or Instagram.",
    color: "bg-amber-50",
    iconColor: "text-amber-600",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Earn Commission",
    desc: "Every sale through your share earns you real money — helping your family live a better life.",
    color: "bg-yellow-50",
    iconColor: "text-yellow-600",
  },
];

export default function StarBookPrimeSocial() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (id: number) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="py-20 px-6 md:px-12 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-orange-100 text-orange-700 text-sm font-bold uppercase tracking-widest mb-5">
            <i className="ri-star-fill text-yellow-500" />
            StarBookPrime Social
            <i className="ri-star-fill text-yellow-500" />
          </div>

          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 leading-tight"
            style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
          >
            Share Your Life.{" "}
            <span className="text-orange-500">Earn Real Money.</span>
          </h2>

          <p
            className="text-xl md:text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-semibold"
            style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
          >
            Welcome everyone to{" "}
            <span className="text-orange-500 font-bold">StarBookPrime</span> — like Facebook, share your life photos and moments with the world.
            Plus, earn{" "}
            <span className="text-amber-600 font-bold">real commissions</span>{" "}
            by sharing verified factory products to your{" "}
            <span className="font-bold text-red-500">YouTube</span>,{" "}
            <span className="font-bold text-gray-900">TikTok</span>, and{" "}
            <span className="font-bold text-pink-500">Instagram</span> fans.
            Together, sharing more means earning more —{" "}
            <span className="text-orange-600 font-bold">for your family's better life.</span>
          </p>
        </div>

        {/* How It Works — 3 Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {steps.map((step, i) => (
            <div
              key={step.title}
              className={`rounded-2xl p-8 border border-orange-100 ${step.color} flex flex-col items-center text-center`}
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-full bg-white mb-5 text-3xl ${step.iconColor}`}>
                <i className={step.icon} />
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-500 text-white text-sm font-bold mb-3">
                {i + 1}
              </div>
              <h3 className="text-xl font-extrabold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Community Posts */}
        <div className="mb-10">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
            <div>
              <h3
                className="text-3xl font-extrabold text-gray-900"
                style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
              >
                Community Stories
              </h3>
              <p className="text-gray-500 text-sm mt-1">Real people sharing real life — and earning real commissions</p>
            </div>
            <Link
              to="/social"
              className="flex items-center gap-1.5 text-orange-500 font-bold text-sm hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Stories <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {lifePosts.map((post) => (
              <div
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden border border-orange-100 hover:border-orange-300 transition-all hover:-translate-y-1"
              >
                {/* Image */}
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.caption}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-orange-500 text-white text-xs font-bold">
                      {post.tag}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className={`px-3 py-1 rounded-full border text-xs font-bold flex items-center gap-1 bg-white ${platformBg[post.platform]}`}>
                      <i className={`${platformIcon[post.platform]} ${platformColor[post.platform]}`} />
                      {post.followers}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5">
                  {/* User */}
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img src={post.avatar} alt={post.user} className="w-full h-full object-cover object-top" />
                    </div>
                    <div>
                      <div className="flex items-center gap-1">
                        <span className="text-sm font-bold text-gray-900">{post.user}</span>
                        <i className="ri-verified-badge-fill text-orange-500 text-xs" />
                      </div>
                      <div className="flex items-center gap-1 text-xs text-gray-400">
                        <i className={`${platformIcon[post.platform]} ${platformColor[post.platform]}`} />
                        <span>{post.followers} followers</span>
                      </div>
                    </div>
                    <div className="ml-auto text-right">
                      <div className="text-xs text-gray-400">Earned</div>
                      <div className="text-base font-extrabold text-green-600">{post.earned}</div>
                    </div>
                  </div>

                  <p className="text-sm text-gray-700 leading-relaxed mb-4 line-clamp-3">{post.caption}</p>

                  {/* Actions */}
                  <div className="flex items-center gap-4 text-gray-400 text-sm border-t border-gray-50 pt-3">
                    <button
                      onClick={() => toggleLike(post.id)}
                      className={`flex items-center gap-1 transition-colors cursor-pointer ${liked[post.id] ? "text-red-500" : "hover:text-red-500"}`}
                    >
                      <i className={liked[post.id] ? "ri-heart-fill" : "ri-heart-line"} />
                      <span className="text-xs">{post.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-orange-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line" />
                      <span className="text-xs">{post.comments}</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-green-500 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line" />
                      <span className="text-xs">Share</span>
                    </button>
                    <button className="ml-auto flex items-center gap-1 text-orange-500 text-xs font-bold hover:text-orange-600 cursor-pointer whitespace-nowrap">
                      <i className="ri-shopping-bag-line" /> Shop & Earn
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Big CTA Banner */}
        <div
          className="rounded-3xl p-10 md:p-14 text-center relative overflow-hidden"
          style={{ background: "linear-gradient(135deg, #B8860B 0%, #DAA520 40%, #FFD700 70%, #DAA520 100%)" }}
        >
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20gold%20sparkle%20light%20rays%20celebration%20background%20minimal%20elegant&width=1200&height=400&seq=sbp-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10">
            <h3
              className="text-3xl md:text-4xl lg:text-5xl font-extrabold mb-4 text-amber-950 leading-tight"
              style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
            >
              Share More. Earn More.{" "}
              <span className="text-amber-800">Live Better.</span>
            </h3>
            <p
              className="text-lg md:text-xl text-amber-900 max-w-3xl mx-auto mb-8 font-semibold leading-relaxed"
              style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
            >
              Welcome to StarBookPrime — where sharing your life on YouTube, TikTok, and Instagram also helps your family earn real commissions from verified factory products. Together we grow, together we earn.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/social"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-extrabold text-base bg-amber-950 text-yellow-400 hover:bg-amber-900 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-camera-line" />
                Start Sharing Your Life
              </Link>
              <Link
                to="/influencer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-extrabold text-base bg-white text-amber-800 hover:bg-amber-50 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-money-dollar-circle-line" />
                Earn Commission Now
              </Link>
            </div>

            {/* Platform icons */}
            <div className="flex items-center justify-center gap-6 mt-8 text-amber-900">
              <div className="flex items-center gap-2 text-sm font-semibold">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-youtube-line text-2xl text-red-600" />
                </div>
                YouTube
              </div>
              <div className="w-1 h-1 rounded-full bg-amber-700" />
              <div className="flex items-center gap-2 text-sm font-semibold">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-tiktok-line text-2xl text-gray-900" />
                </div>
                TikTok
              </div>
              <div className="w-1 h-1 rounded-full bg-amber-700" />
              <div className="flex items-center gap-2 text-sm font-semibold">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-instagram-line text-2xl text-pink-500" />
                </div>
                Instagram
              </div>
              <div className="w-1 h-1 rounded-full bg-amber-700" />
              <div className="flex items-center gap-2 text-sm font-semibold">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-facebook-circle-line text-2xl text-amber-800" />
                </div>
                Facebook
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
